_ = require 'lodash'
$ = require 'jquery'
ko = require 'knockout'
React = require 'react'
ReactDOM = require 'react-dom'
{ Icon } = require '../../../main/scripts/components/icons/Icon'
# Custom Knockout JS Bindings

### Bindings that do new things ###

keyHandler = (code) ->
    init: (el, valueAccessor, allBindingsAccessor, viewModel, bindingContext) ->
        $(el).keydown (e) ->
            fn = ko.utils.unwrapObservable valueAccessor()
            return true unless e.which == code

            fn.call bindingContext.$data, bindingContext.$data, e
            false

# enter, escape: fn
# Handlers for executing a function when enter or escape are pressed in an input
ko.bindingHandlers.enter = keyHandler 13
ko.bindingHandlers.escape = keyHandler 27

# This binding will select the text inside an input or textarea based on a boolean observable value.
ko.bindingHandlers.selected = {
    init: (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) ->
        valueAccessor().subscribe (value) ->
            # Defer the DOM update to the next tick in case the input is not yet visible
            _.defer(-> element.select()) if value
}

### Bindings that combine multiple old things or provide shortcuts ###

# disable: value, css: { disabled: value }
ko.bindingHandlers.disabled = {
    init: (el, valueAccessor) ->
        ko.bindingHandlers.disable.init? el, valueAccessor
        ko.bindingHandlers.css.init? el, valueAccessor

    update: (el, valueAccessor) ->
        value = ko.utils.unwrapObservable valueAccessor()
        ko.bindingHandlers.disable.update el, -> value
        ko.bindingHandlers.css.update el, -> { disabled: value }
}

# css: { visible: value }
ko.bindingHandlers.fadeVisible = {
    init: (el, valueAccessor) ->
        ko.bindingHandlers.css.init? el, valueAccessor

    update: (el, valueAccessor) ->
        value = ko.utils.unwrapObservable valueAccessor()
        ko.bindingHandlers.css.update el, -> { visible: value }
}

ko.bindingHandlers.reactIcon =
  init: (element, valueAccessor) ->
    iconProps = ko.unwrap(valueAccessor()) or {}

    ReactDOM.render(
      React.createElement(Icon, iconProps),
      element
    )
    controlsDescendantBindings: true

# ko.bindingHandlers.reactIconInline =
#   init: (element, valueAccessor) ->
#     props = ko.unwrap(valueAccessor()) or {}

#     # 1. Capture current text
#     originalText = element.textContent?.trim() or ''

#     # 2. Clear element and create icon container
#     while element.firstChild
#       element.removeChild(element.firstChild)

#     iconContainer = document.createElement('span')
#     iconContainer.style.marginRight = '0.25em'

#     # 3. Create text node
#     textNode = document.createTextNode(originalText)

#     # 4. Append both
#     element.appendChild(iconContainer)
#     element.appendChild(textNode)

#     # 5. Render icon
#     ReactDOM.render(
#       React.createElement(Icon, props),
#       iconContainer
#     )

#     return { controlsDescendantBindings: false }

ko.bindingHandlers.reactIconInline =
  init: (element, valueAccessor) ->
    props = ko.unwrap(valueAccessor()) or {}

    # 1. Capture current text content
    originalText = element.textContent?.trim() or ''

    # 2. Clear element
    while element.firstChild
      element.removeChild(element.firstChild)

    # 3. Create icon container
    iconContainer = document.createElement('span')
    iconContainer.style.display = 'inline-flex'
    iconContainer.style.alignItems = 'center'
    iconContainer.style.verticalAlign = 'bottom'
    iconContainer.style.marginRight = '5px'

    # Optional width & height
    if props.width? then iconContainer.style.width = props.width + 'px'
    if props.height? then iconContainer.style.height = props.height + 'px'

    # 4. Append icon container and text
    textNode = document.createTextNode(originalText)
    element.appendChild(iconContainer)
    element.appendChild(textNode)

    # 5. Render Icon
    ReactDOM.render(
      React.createElement(Icon, props),
      iconContainer
    )

    return { controlsDescendantBindings: false }

